import axios from 'axios';
import PropTypes from 'prop-types';
import React, { createContext, useEffect, useState } from 'react';

export const MaintenanceContext = createContext({});

export const MaintenanceContextProvider = (props) => {
    const { children } = props;
    const [maintenanceMode, setmaintenanceMode] = useState(false);
    const host = window.location.origin;
    const fetchMaintenance = async () => {
        try {
            const response = await axios.get(`${host}/maintenance.json`, {
                headers: {
                    'Cache-Control': 'no-cache',
                },
            });
            if (response?.data && response?.data?.inMaintenanceMode === 'Y') {
                setmaintenanceMode(true);
                return () => undefined;
            }
            setmaintenanceMode(false);
            return () => undefined;
        } catch (e) {
            setmaintenanceMode(false);
        }
        return () => undefined;
    };

    useEffect(() => {
        if (!host.includes('localhost')) {
            fetchMaintenance();
        }
    }, []);

    return (
        <MaintenanceContext.Provider
            value={{
                maintenanceMode,
                fetchMaintenance,
            }}
        >
            {children}
        </MaintenanceContext.Provider>
    );
};

MaintenanceContextProvider.propTypes = {
    children: PropTypes.element.isRequired,
};
